// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputCheckbox_wrapper__9F_Qb","checkbox":"InputCheckbox_checkbox__jMjPC","label":"InputCheckbox_label__wbRGs","labelError":"InputCheckbox_labelError__cqC7h"};